var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 17.5H5.83331V15.8333H7.49998V15H2.49998C1.5795 15 0.833313 14.2538 0.833313 13.3333V4.16667C0.833313 3.24619 1.5795 2.5 2.49998 2.5H17.5C18.4205 2.5 19.1666 3.24619 19.1666 4.16667V13.3333C19.1666 14.2538 18.4205 15 17.5 15H12.5V15.8333H14.1666V17.5ZM2.49998 4.16667V13.3333H17.5V4.16667H2.49998Z",
    fill: "#38E25D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectedIcon);
export default __webpack_public_path__ + "static/media/connected-icon.5033d6fc0b67e29542644f924eb9cd3d.svg";
export { ForwardRef as ReactComponent };